var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoftLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "436.8px",
    height: "566.9px",
    viewBox: "0 0 436.8 566.9",
    enableBackground: "new 0 0 436.8 566.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 105.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 117,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 128.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 140.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 152,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 163.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 175.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 187,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 198.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 210.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 222,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 233.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 245.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 257,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 268.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 280.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 292,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 303.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 315.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 327,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 338.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 350.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 362,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 373.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 385.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 397,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 408.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 420.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 432,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 57.7,
    cy: 443.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 59.4,
    cy: 455.3,
    r: 2.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 105.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 117,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 128.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 140.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 152,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 163.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 175.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 187,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 198.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 210.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 222,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 233.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 245.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 257,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 268.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 280.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 292,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 303.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 315.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 327,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 338.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 350.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 362,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 373.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 385.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 397,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 408.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 420.3,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 432,
    r: 2.9
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 443.7,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#706F6F",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    d: "M66,498.3h-4.8c-1.8,0-3.2-1.5-3.2-3.2 v-30.3c0-1.8,1.5-3.2,3.2-3.2H66c1.8,0,3.2,1.5,3.2,3.2V495C69.3,496.8,67.8,498.3,66,498.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    d: "M57.7,102.4v352.1l11.2-1.4 c0-8.7,0-350.6,0-350.6H57.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 1.2079,
    strokeMiterlimit: 10,
    cx: 68.9,
    cy: 453.6,
    r: 2.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.7343,
    strokeMiterlimit: 10,
    d: "M37.8,347c0,0-1.6,0.6-1.7,2.6 s-0.4,8.6-0.4,8.6s-0.2,2,2.1,2.8c2.3,0.8,14.5,3.6,18.4,4.5s28.5,7.5,35.3,8.6c6.7,1.2,35.4,6.4,41.3,7.2 c5.9,0.9,49.6,5.4,58.2,5.7s50.2-0.2,56.1,0c5.9,0.2,34.4-2.2,40.7-2.8c6.3-0.6,40.6-6.1,43.5-6.7s45.9-10.5,48-11.2 c2.1-0.7,18.6-5.6,19.7-6c1.1-0.4,2-0.7,2.3-3.1c0.3-2.4,0.2-6.7,0.2-6.7s0.2-1.1-0.4-1.4c-0.6-0.3-2-1-2-1l-31.9,8.4l-41.4,7.7 l-52.5,7.2l-65.7,2.1l-73.2-7.2l-62.5-11.7l-33.2-8.9L37.8,347z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.7343,
    strokeMiterlimit: 10,
    d: "M38.6,332.8c0,0-2.3,1.1-2.4,3 c-0.1,1.9,0,8.2,0,8.2s-0.8,1.6,1.4,2.4c2.2,0.7,15,5,18.3,5.7c3.3,0.7,38.1,8.5,45.7,10.1c7.6,1.7,52.6,8.8,63.8,9.6 s52.9,3.3,52.9,3.3s53.5-2.2,61.1-3.1c7.6-0.9,56.5-7.7,63.3-9c6.8-1.3,45.1-10.4,50.7-11.9s7.1-2.3,7.1-2.3s1.8,0.1,1.8-3.8 c0-3.9,0-7,0-7s-0.4-2.6-2.3-2.7c-1.9-0.1-1.9-1-1.9-1l-20.4,5.5l-71.4,14.8l-52.6,6.4l-53.3-0.5l-29.7-0.9l-37.3-5l-51.1-10.1 L46,333.7l-6.4-1.9L38.6,332.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.7343,
    strokeMiterlimit: 10,
    d: "M38.4,317c0,0-2.7,1.2-2.7,4.9 c0,3.7,0,6,0,6s-0.6,2.6,2.7,4.1c3.3,1.4,22.1,7.8,26.5,8.9s55.2,13.7,67,15.2s66.4,6.7,90.9,6.2c24.5-0.5,86.1-6.5,90.9-7.1 c4.7-0.5,40.6-7.4,44.5-8.3c4-0.9,39.4-11.6,41.8-12.4s2.4-1.2,2.4-4.9c0-3.6,0.3-6.5-1.2-8.6c-1.4-2.1-2.9-2.6-2.9-2.6l-1.8-1.6 L318,333.7l-44.9,6.6l-61.5,2l-42.1-3.1l-46.7-7.3l-82.8-16.4L38.4,317z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.7343,
    strokeMiterlimit: 10,
    d: "M37.5,68.1h360.7v203.7 c0,0,4.1,15.8,4.1,24.7c0,8.9,0,15.1,0,15.1s1.3,4.8-6,6.6c-7.3,1.8-28.1,7.5-44.8,10.8c-16.7,3.3-76,12.8-86.5,13.4 c-10.5,0.5-59.2,2-81.4,0c-22.2-2-84.9-12.1-96.8-14.6C74.9,325.2,42.2,317,39,316.1c-3.2-0.9-5.3-2.2-4.3-12.3 c1.1-10.1,3-21.6,3-26.9C37.7,271.6,37.5,68.1,37.5,68.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftLeft);
export default __webpack_public_path__ + "static/media/soft_left.d34b70abdddbacae3158579bd1f192ba.svg";
export { ForwardRef as ReactComponent };